<template>
    <b-button variant="success" @click="toInserir()" v-if="mostrarBtnInserir"
        >Inserir Unidade Regional</b-button
    >
</template>

<script>
export default {
    methods: {
        toInserir() {
            this.$router.push({
                name: 'AppSebrae_Consultorias_UnidadesRegionais_Inserir'
            })
        }
    },

    computed: {
        mostrarBtnInserir() {
            return this.$temAcessoView('APPSE-CONS-UR-00')
        }
    }
}
</script>